import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_psp4uwy7qx: FaireBrandEntity = {
  token: "b_psp4uwy7qx",
  type: "brand",
  name: "Holy Halvah",
  avatarUrl:
    "https://cdn.faire.com/fastly/8be8177c622ffded84555f1934a3ac32835da39d86fcdb86ef8dc4175be33bc6.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4027682115d8f3bf6d422da53615f8e116125ab9a01bfb72b22149e592e0022f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8be8177c622ffded84555f1934a3ac32835da39d86fcdb86ef8dc4175be33bc6.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4027682115d8f3bf6d422da53615f8e116125ab9a01bfb72b22149e592e0022f.jpeg",
  location: "Lincoln, VT, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "At Holy Halvah, every bar is crafted by hand, one small batch at a time—just 56 bars\nper batch. We use only four simple, real-food ingredients: organic sesame tahini, pure\nVermont maple syrup, sea salt, and pure vanilla extract. The result? A clean, satisfying\ntreat that’s unexpectedly addictive.\n\nWe're a true family business, with everyone pitching in—from our kids to our moms.\nEvery available hand helps bring Holy Halvah to life.\n\nOur tahini is carefully sourced and milled to our exact specifications, ensuring the\nperfect texture and flavor. Our maple syrup local as it gets, produced by\nour friend and neighbor, Don Gale of Twin Maple Sugarworks. Don is one of the few\nremaining sugar makers who still uses a traditional wood-fired evaporator. He’s not just\nour syrup supplier—he's also one of Holy Halvah’s earliest and most enthusiastic\nsupporters. Thank you, Don!\n\nWhat makes this journey even sweeter is that we genuinely love what we do. As\npartners in life and business, we make an amazing team—balancing creativity, grit, and\na shared passion for crafting clean, joyful food.\n\nWe're driven by the belief that a simple, delicious snack can spark positive change.\nWhether it’s fueling your day or supporting our community, Holy Halvah is our way of\nmaking life even sweeter.",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:53.495Z",
    importedBy: "entity-db-cli",
  },
};
